@let isLoading = isLoadingComments();

<div class="comments-section" [dataSelector]="dataSelector + '-container'">
  <!-- Thread View Container -->
  @if (isViewingThread()) {
    <div class="view-container" [dataSelector]="dataSelector + '-thread-view-container'">
      @if (threadComment(); as threadComment) {
        <div #threadView class="thread-view">
          <!-- Back Button -->
          <div class="thread-back" [dataSelector]="dataSelector + '-thread-back'">
            <aiwyn-icon
              name="chevron-left"
              class="back-icon-button"
              (click)="closeThread()"
              [dataSelector]="dataSelector + '-back-button'"
            />
            <span class="thread-back-text" [dataSelector]="dataSelector + '-thread-back-text'"
              >{{ getRepliesCount(threadComment) }} replies to {{ threadComment.author.firstName }}
              {{ threadComment.author.lastName }}</span
            >
          </div>

          <!-- Parent Comment -->
          <div class="comment-item" [dataSelector]="dataSelector + '-parent-comment'" [attr.data-message-id]="threadComment.id">
            <div class="comment-user">
              <app-avatar
                [avatarInput]="threadComment.author"
                [domain]="threadComment.author.isStaff ? 'staff' : 'contact'"
                (onAvatarClick)="handleMessageClicked(threadComment)"
                [dataSelector]="dataSelector + '-parent-comment-avatar'"
              ></app-avatar>
              <span class="author-name" [dataSelector]="dataSelector + '-parent-comment-author'"
                >{{ threadComment.author.firstName }} {{ threadComment.author.lastName }}</span
              >
            </div>

            <div class="thread-wrapper" [dataSelector]="dataSelector + '-parent-comment-wrapper'">
              <div class="thread-line"></div>

              <div class="comment-content" [dataSelector]="dataSelector + '-parent-comment-content'">
                @if (threadComment.context) {
                  <div class="comment-header-info">
                    <span class="comment-context" [dataSelector]="dataSelector + '-parent-comment-context'">
                      {{ threadComment.context }}
                    </span>
                  </div>
                }

                <ng-container
                  *ngTemplateOutlet="commentContent; context: { $implicit: { data: threadComment, selector: 'parent-comment-text' } }"
                />

                <div class="comment-timestamp" [dataSelector]="dataSelector + '-parent-comment-timestamp'">
                  {{ getTimeAgo(threadComment.timestamp) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Replies -->
          @if (threadComment.replies && threadComment.replies.length > 0) {
            <div [dataSelector]="dataSelector + '-replies-container'">
              @for (reply of threadComment.replies; track reply.id) {
                <div
                  class="comment-item"
                  [attr.data-message-id]="reply.id"
                  (click)="handleMessageClicked(reply)"
                  [dataSelector]="dataSelector + '-reply'"
                >
                  <div class="comment-user" [dataSelector]="dataSelector + '-reply-user'">
                    <app-avatar [avatarInput]="reply.author" [domain]="reply.author.isStaff ? 'staff' : 'contact'"></app-avatar>
                    <span class="author-name" [dataSelector]="dataSelector + '-reply-author'">
                      {{ reply.author.firstName }} {{ reply.author.lastName }}
                    </span>
                    @if (reply.isUnread) {
                      <div class="status" [dataSelector]="dataSelector + '-reply-unread-status'"></div>
                    }
                  </div>

                  <div class="thread-wrapper">
                    @if (!$last) {
                      <div class="thread-line"></div>
                    }
                    <div class="comment-content" [ngClass]="$last ? 'last-of-thread' : ''">
                      <ng-container *ngTemplateOutlet="commentContent; context: { $implicit: { data: reply, selector: 'reply-text' } }" />
                      <div class="comment-timestamp" [dataSelector]="dataSelector + '-reply-timestamp'">
                        {{ getTimeAgo(reply.timestamp) }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>

        <!-- Send Input (Thread View) -->
        @if (!shouldMaskComments()) {
          <ng-container *ngTemplateOutlet="commentInputTemplate"></ng-container>
        }
      }
    </div>
  }

  <!-- Comments List Container -->
  @if (!isViewingThread()) {
    <div class="view-container" [dataSelector]="dataSelector + '-list-view-container'">
      <div #commentsList class="comments-list" [dataSelector]="dataSelector + '-comments-list'">
        @for (comment of displayComments(); track comment.id) {
          <div
            class="comment-item"
            [attr.data-message-id]="comment.id"
            (click)="handleMessageClicked(comment)"
            [dataSelector]="dataSelector + '-comment'"
          >
            <!-- Avatar and Main Content -->
            <div class="comment-user" [dataSelector]="dataSelector + '-comment-user'">
              <app-avatar
                [avatarInput]="comment.author"
                [domain]="comment.author.isStaff ? 'staff' : 'contact'"
                [dataSelector]="dataSelector + '-comment-avatar'"
              ></app-avatar>
              <span class="author-name" [dataSelector]="dataSelector + '-comment-author'"
                >{{ comment.author.firstName }} {{ comment.author.lastName }}</span
              >
              @if (comment.isUnread) {
                <div class="status" [dataSelector]="dataSelector + '-comment-unread-status'"></div>
              }
            </div>

            <div class="comment-content" [dataSelector]="dataSelector + '-comment-content'">
              <!-- Author and Context -->
              @if (comment.context) {
                <div class="comment-header-info" [dataSelector]="dataSelector + '-comment-header-info'">
                  <span class="comment-context" [dataSelector]="dataSelector + '-comment-context'">{{ comment.context }}</span>
                </div>
              }

              <!-- Comment Text -->
              <ng-container *ngTemplateOutlet="commentContent; context: { $implicit: { data: comment, selector: 'comment-text' } }" />

              <!-- Flagged Files -->
              @if (comment.flaggedFiles?.length > 0) {
                @for (flaggedItem of comment.flaggedFiles; track flaggedItem) {
                  <div class="flagged-file" [dataSelector]="dataSelector + '-comment-flagged-file'">
                    <aiwyn-icon
                      name="flag-pennant"
                      namespace="phosphor"
                      [width]="12"
                      [height]="12"
                      class="activity-item__flagged-file-icon"
                      [dataSelector]="dataSelector + '-comment-flag-icon'"
                    />
                    <div class="file-name" tooltipOverflow [dataSelector]="dataSelector + '-comment-file-name'">
                      {{ flaggedItem }}
                    </div>
                  </div>
                }
              }

              <!-- Timestamp -->
              <div class="comment-timestamp" [dataSelector]="dataSelector + '-comment-timestamp'">
                <div>{{ getTimeAgo(comment.timestamp) }}</div>
                @if (!comment.isComment) {
                  <aiwyn-icon
                    name="info"
                    [width]="12"
                    [height]="12"
                    class="firm-requirement-info icon-color-gray-400"
                    [tooltip]="firmResponseSubmission"
                  />
                }
              </div>

              @if (comment.isComment) {
                <div class="replies-block" [dataSelector]="dataSelector + '-comment-replies-block'">
                  <!-- Reply Button -->
                  @if (!comment.isMasked) {
                    <button class="reply-button" (click)="startReply(comment.id)" [dataSelector]="dataSelector + '-comment-reply-button'">
                      <img alt="Reply" src="assets/ArrowBendUpLeft.svg" />
                      <span class="reply-text">Reply</span>
                    </button>
                  }

                  <!-- Replies Link -->
                  @if (hasReplies(comment)) {
                    <button
                      class="replies-link"
                      (click)="viewThread(comment.id)"
                      [dataSelector]="dataSelector + '-comment-view-thread-button'"
                    >
                      <span class="replies-count" [dataSelector]="dataSelector + '-comment-replies-count'"
                        >{{ getRepliesCount(comment) }} Replies</span
                      >
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        } @empty {
          @if (isActivityLoading()) {
            <div class="activity-loading-panel" [dataSelector]="dataSelector + '-activity-loading'">
              <mat-spinner diameter="24"></mat-spinner>
              <span [dataSelector]="dataSelector + '-activity-loading-message'">Loading activities...</span>
            </div>
          } @else {
            <div class="activity-empty-panel" [dataSelector]="dataSelector + '-activity-empty'">
              <span [dataSelector]="dataSelector + '-activity-empty-message'">No activity to display</span>
            </div>
          }
        }
      </div>

      <!-- Send Input (Main List View) -->
      @if (showCommentInput() && !shouldMaskComments()) {
        <ng-container *ngTemplateOutlet="commentInputTemplate"></ng-container>
      }
    </div>
  }
</div>

<!-- Comment Input Template -->
<ng-template #commentInputTemplate>
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" [dataSelector]="dataSelector + '-loading-bar'"></mat-progress-bar>
  }
  <div class="comments-input-area">
    <div class="textarea-wrapper">
      <textarea
        class="comments-form-textarea"
        [formControl]="messageControl"
        [placeholder]="inputPlaceholder()"
        (keydown.enter)="handleKeyDown($event)"
        rows="2"
        [dataSelector]="dataSelector + '-textarea'"
      ></textarea>
      <button
        type="button"
        class="send-icon-button"
        [disabled]="isLoading || !messageControl.value?.trim()"
        (click)="handleSendMessage()"
        [dataSelector]="dataSelector + '-send-button'"
      >
        <img alt="Send" height="16" src="assets/vector.svg" width="16" [dataSelector]="dataSelector + '-send-icon'" />
      </button>
    </div>
  </div>
</ng-template>

<ng-template #commentContent let-comment>
  @if (comment.data.isMasked) {
    <div class="w-100 bg-color-gray-1000 color-gray-400 rounded-all-1 p-2 body-300">
      Comment is not visible due to this request’s restriction settings.
    </div>
  } @else {
    <div class="comment-text" [dataSelector]="dataSelector + '-' + comment.selector">{{ comment.data.text }}</div>
  }
</ng-template>

<ng-template #firmResponseSubmission>
  <div>
    <p>Review responses can’t</p>
    <p class="w-100 text-center">be replied to just yet!</p>
  </div>
</ng-template>
